var React = require('react');

function FooterElement (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"6","width":"11","height":"11","fill":"#262556","key":0}),React.createElement("rect",{"x":"30","y":"11","width":"11","height":"11","fill":"#B58CFF","key":1}),React.createElement("rect",{"y":"22","width":"11","height":"11","fill":"#80E8E4","key":2}),React.createElement("rect",{"x":"11","y":"22","width":"11","height":"11","fill":"#80E8E4","key":3})]);
}

FooterElement.defaultProps = {"width":"41","height":"33","viewBox":"0 0 41 33","fill":"none"};

module.exports = FooterElement;

FooterElement.default = FooterElement;
